import { QuestionsServiceInterface } from 'domain/services';
import {
  ReorderQuestionsUseCaseInterface,
  CreateQuestionUseCaseInterface,
  DeleteQuestionUseCaseInterface,
  GetAllQuestionsUseCaseInterface,
  GetQuestionByIdUseCaseInterface,
  UpdateQuestionUseCaseInterface,
  CloneQuestionUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  getAllQuestions: GetAllQuestionsUseCaseInterface;
  reorderQuestions: ReorderQuestionsUseCaseInterface;
  createQuestion: CreateQuestionUseCaseInterface;
  updateQuestion: UpdateQuestionUseCaseInterface;
  deleteQuestion: DeleteQuestionUseCaseInterface;
  getQuestionById: GetQuestionByIdUseCaseInterface;
  cloneQuestion: CloneQuestionUseCaseInterface;
}

export class QuestionsService implements QuestionsServiceInterface {
  private readonly _getAllQuestions: GetAllQuestionsUseCaseInterface;
  private readonly _reorderQuestions: ReorderQuestionsUseCaseInterface;
  private readonly _createQuestion: CreateQuestionUseCaseInterface;
  private readonly _updateQuestion: UpdateQuestionUseCaseInterface;
  private readonly _deleteQuestion: DeleteQuestionUseCaseInterface;
  private readonly _getQuestionById: GetQuestionByIdUseCaseInterface;
  private readonly _cloneQuestion: CloneQuestionUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllQuestions = usecases.getAllQuestions;
    this._reorderQuestions = usecases.reorderQuestions;
    this._createQuestion = usecases.createQuestion;
    this._updateQuestion = usecases.updateQuestion;
    this._deleteQuestion = usecases.deleteQuestion;
    this._getQuestionById = usecases.getQuestionById;
    this._cloneQuestion = usecases.cloneQuestion;
  }

  getAllQuestions(
    params: GetAllQuestionsUseCaseInterface.Params,
  ): Promise<GetAllQuestionsUseCaseInterface.Result> {
    return this._getAllQuestions.execute(params);
  }

  reorderQuestions(
    params: ReorderQuestionsUseCaseInterface.Params,
  ): Promise<ReorderQuestionsUseCaseInterface.Result> {
    return this._reorderQuestions.execute(params);
  }

  updateQuestion(
    params: UpdateQuestionUseCaseInterface.Params,
  ): Promise<UpdateQuestionUseCaseInterface.Result> {
    return this._updateQuestion.execute(params);
  }

  createQuestion(
    params: CreateQuestionUseCaseInterface.Params,
  ): Promise<CreateQuestionUseCaseInterface.Result> {
    return this._createQuestion.execute(params);
  }

  getQuestionById(
    params: GetQuestionByIdUseCaseInterface.Params,
  ): Promise<GetQuestionByIdUseCaseInterface.Result> {
    return this._getQuestionById.execute(params);
  }

  deleteQuestion(
    params: DeleteQuestionUseCaseInterface.Params,
  ): Promise<DeleteQuestionUseCaseInterface.Result> {
    return this._deleteQuestion.execute(params);
  }

  cloneQuestion(
    params: CloneQuestionUseCaseInterface.Params,
  ): Promise<CloneQuestionUseCaseInterface.Result> {
    return this._cloneQuestion.execute(params);
  }
}
